import React from 'react';

export const LoginCard = ({ children }) => (
    <div className="card mb-4 mt-5 mx-4 mx-sm-0 position-relative">
        <div className="wd-50 bg-white p-2 rounded-circle shadow-lg position-absolute translate-middle top-0 start-50">
            <img src="/assets/logo/logo-abbr.png" alt="" className="img-fluid" />
        </div>
        <div className="card-body p-sm-5">
            {children}
        </div>
    </div>
);
